import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=a00d0b5e&scoped=true&"
import script from "./Switcher.vue?vue&type=script&lang=ts&"
export * from "./Switcher.vue?vue&type=script&lang=ts&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=a00d0b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00d0b5e",
  null
  
)

export default component.exports